export default __webpack_public_path__ + "static/assets/med_x_insulin_pen.e885d204.png";